module.exports = __webpack_public_path__ + "img/queue_card_small_disabled.ec54a222.svg";